import { call, put, delay } from "redux-saga/effects";
import { reviewApi, sampleApi } from "@services/api";
import { getTotalReviewInstructorActions } from "../slices";

function* getTotalReviewInstructorWorker({ payload }) {
  //   yield delay(300);
  try {
    yield put(getTotalReviewInstructorActions.pending());
    const response = yield call(reviewApi.getTotalReviewInstructor, payload);
    yield put(getTotalReviewInstructorActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getTotalReviewInstructorActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getTotalReviewInstructorWorker };
